import SvgImage from '@/components/Module/SvgImage';
import React from 'react';

type P = {
  svgImageName: string;
  title: string;
  subTitle: string;
};

const IconContent = ({ svgImageName, title, subTitle }: P) => {
  return (
    <div
      style={{
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px 0',
        borderRadius: '8px',
        backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
        gap: '8px',
        textAlign: 'center',
      }}
    >
      <SvgImage name={svgImageName} />
      <div>
        <div
          style={{
            color: 'var(--dk-accent, #06C)',
            fontSize: '12px',
            fontWeight: '700',
            lineHeight: '18px',
          }}
        >
          {title}
        </div>
        <div style={{ fontSize: '14px', lineHeight: '20px' }}>{subTitle}</div>
      </div>
    </div>
  );
};

export default IconContent;
